var wishlist = {
    'getWishLists': function (product_id) {
        customAjaxRequest('index.php?route=account/my_wishlist/getWishLists', 'post', 'product_id=' + product_id, function () {
            $('#wishlistModal').remove();
        });
    }
}
window.wishlist = wishlist;